import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const userServices = {
  login,
  logout,
  getCurrectLoginUser,
  changePassword,
  forgotPassword,
  resetPassword,
  getUserPermission,
  getUserLoginHistoryData,
  getUserFailedLoginData,
  generateQRCode,
  getQRData,
  checkQRCode,
  enableTwoFactorAuth,
  disableTwoFactorAuth,
  showQRCode,
  twoFactorAuthType,
  getTwoFactorAuthType,
  emailOTPFor2FA,
  enableTwoFactorAuthByEmail,
  disableTwoFactorAuthByEmail,
  verifyTwoFAForEmailLogin,
  verifyTwoFAForAppLogin,
  disableTwoFactorAuthByAdmin,
};

async function login(userId, password, roleData, fcmToken) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userId, password, roleData, fcmToken }),
  };

  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}login`,
    requestOptions
  );

  const data = await response.json();
  handleResponse(data);

  let loginType = data?.loginType || "";
  let firstName = data?.userData?.firstName;
  let lastName = data?.userData?.lastName;
  let role = data?.userData?.roleType;
  let authType = data?.userData?.authType;
  let twoFA = data?.userData?.twoFA;
  let permission = data?.userData?.permissions;
  let updatePassword = data?.userData?.updatePassword;
  if (data.statusCode === 200) {
    let permissionData = await getUserPermission(userId)
    localStorage.setItem("loginType", JSON.stringify(loginType));
    localStorage.setItem("permissionData", JSON.stringify(permissionData));
    localStorage.setItem("token", JSON.stringify(data.token));
    localStorage.setItem("twoFA", JSON.stringify(twoFA));
    localStorage.setItem("authType", JSON.stringify(authType));
    localStorage.setItem("role", JSON.stringify(role));
    localStorage.setItem("userId", JSON.stringify(userId));
    localStorage.setItem("permission", JSON.stringify(permission));
    localStorage.setItem("updatePassword", JSON.stringify(updatePassword));
    localStorage.setItem(
      "firstName",
      JSON.stringify(firstName != null ? firstName : "No")
    );
    localStorage.setItem(
      "lastName",
      JSON.stringify(lastName != null ? lastName : "")
    );
    window.location.href = "/home";
  }
  return data;
}

async function logout(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}logout`,
    headersWithAuth("PUT", userData, headers)
  );

  const data = await response.json();
  handleResponse(data);
  if(data?.statusCode === 200){
    localStorage.removeItem("studyTabs");
    localStorage.clear();
    window.location.href = "/login";
  }
}

async function getCurrectLoginUser() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getCurrentUser`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getUserPermission(userId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUserPermission/${userId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function changePassword(userData, history) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}changePassword`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  if (data.statusCode === 200) {
    localStorage.setItem("updatePassword", JSON.stringify(true));
    window.location.reload();
  }
}

async function resetPassword(userData, history) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}resetPassword`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  if (data.statusCode) {
    window.location.href = "/login";
  }
}

async function forgotPassword(userData, history) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}forgotPassword`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getUserLoginHistoryData(userId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUserLoginHistoryData/${userId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getUserFailedLoginData(userId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUserFailedLoginData/${userId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Generate QR code
async function generateQRCode() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}generateQRCode`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get QR Data
async function getQRData() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getQRData`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Show QR code
async function showQRCode() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}showQRCode`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Check QR & OTP
async function checkQRCode(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}checkQRCode`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Enable Two Factor Auth 
async function enableTwoFactorAuth(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}enableTwoFactorAuth`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Disable Two Factor Auth 
async function disableTwoFactorAuth(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}disableTwoFactorAuth`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Auth Type
async function getTwoFactorAuthType() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTwoFactorAuthType`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Update Auth Type
async function twoFactorAuthType(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}twoFactorAuthType`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Send OTP for Email two factor auth
async function emailOTPFor2FA(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}emailOTPFor2FA`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Disable Email Two Factor Auth 
async function disableTwoFactorAuthByEmail(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}disableTwoFactorAuthByEmail`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Enable Email Two Factor Auth 
async function enableTwoFactorAuthByEmail(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}enableTwoFactorAuthByEmail`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Verify Two FA for Email Login
async function verifyTwoFAForEmailLogin(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}verifyTwoFAForEmailLogin`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Verify Two FA for App Login
async function verifyTwoFAForAppLogin(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}verifyTwoFAForAppLogin`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Disable Two Factor Auth by Admin
async function disableTwoFactorAuthByAdmin(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}disableTwoFactorAuthByAdmin`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}